import { Component, ElementRef, computed, inject, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { ButtonModule } from 'primeng/button';
import { LayoutService } from '@/app/layout/service/layout.service';
import { AuthService } from '@/app/core/auth/auth.service';
import { AppBreadcrumb } from './app.breadcrumb';

@Component({
    selector: '[app-topbar]',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, AppBreadcrumb, ButtonModule],
    template: `<div class="layout-topbar">
        <div class="topbar-start">
            <button #menubutton type="button" class="topbar-menubutton p-link p-trigger hover:cursor-pointer" (click)="onMenuButtonClick()">
                <i class="pi pi-bars"></i>
            </button>
            <nav app-breadcrumb class="topbar-breadcrumb"></nav>
        </div>

        <div class="topbar-end">
            <ul class="topbar-menu">
                <!-- El configurador de tema no le sirve a nadie en el celular. -->
                <li class="ml-3 hidden lg:block">
                    <p-button icon="pi pi-palette" rounded (onClick)="onConfigButtonClick()"></p-button>
                </li>
                <li class="topbar-profile">
                    <button
                        type="button"
                        class="p-link hover:cursor-pointer"
                        (click)="onProfileButtonClick()"
                        [title]="adminName()"
                    >
                        <span class="flex items-center justify-center w-9 h-9 rounded-full bg-primary text-primary-contrast font-semibold text-sm">
                            {{ initials() }}
                        </span>
                    </button>
                </li>
            </ul>
        </div>
    </div>`
})
export class AppTopbar {
    @ViewChild('menubutton') menuButton!: ElementRef;

    private layoutService = inject(LayoutService);
    private auth = inject(AuthService);

    adminName = computed(() => this.auth.currentAdmin()?.name ?? '');

    initials = computed(() => {
        const name = this.auth.currentAdmin()?.name;
        if (!name) return '?';
        const parts = name.trim().split(/\s+/);
        if (parts.length === 1) return parts[0][0]?.toUpperCase() ?? '?';
        return ((parts[0][0] ?? '') + (parts[parts.length - 1][0] ?? '')).toUpperCase();
    });

    onMenuButtonClick() {
        this.layoutService.toggleMenu();
    }

    onProfileButtonClick() {
        this.layoutService.toggleProfileSidebar();
    }

    onConfigButtonClick() {
        this.layoutService.toggleConfigSidebar();
    }
}
